var map = {
	"./authenticate1.jpg": "30ff",
	"./duty1.jpg": "e5c2",
	"./duty2.jpg": "d1ff",
	"./duty3.jpg": "c56e",
	"./goin1.png": "c8d0",
	"./news1.png": "38dd",
	"./news2.jpg": "9abd",
	"./news3.png": "06e2",
	"./talents1.jpg": "ed52",
	"./talents3.jpg": "0fda",
	"./talents4.jpg": "5fdb",
	"./talents4.png": "9d96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb9b";